import ApplicationAdapter from './application';
import DS from 'ember-data';

export default class IntegrationAdapter extends ApplicationAdapter {
  shouldReloadAll(store: DS.Store) {
    if (store.peekAll('integration').length) {
      return false;
    }

    return true;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your adapters.
declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    integration: IntegrationAdapter;
  }
}
